import React, { useReducer, createContext } from "react";
import axios from "axios";

const initialState = {
  restaurantData: {},
};

const initRelState = {
  reload: null,
};

const RestaurantContext = createContext({
  restaurantData: {},
  setRestaurantData: (data) => {},
  setRestaurantTiming: (data) => {},
});

const ReloadContext = createContext({
  reload: null,
  setReload: (data) => {},
});

function RestaurantDataReducer(state, action) {
  switch (action.type) {
    case "SET_REST_DATA":
      return {
        ...state,
        restaurantData: action.payload,
      };
    case "SET_REST_TIMING":
      let restdata = state.restaurantData;
      restdata.readable_timing = action.payload;
      return {
        ...state,
        restaurantData: restdata,
      };

    default:
      return state;
  }
}

function ReloadReducer(state, action) {
  switch (action.type) {
    case "SET_RELOAD":
      return {
        ...state,
        reload: action.payload,
      };
    default:
      break;
  }
}

function RestaurantDataProvider(props) {
  const [state, dispatch] = useReducer(RestaurantDataReducer, initialState);

  // React.useEffect(async () => {
  //   const { data } = await axios.get(
  //     process.env.REACT_APP_API_URL + "restaurant"
  //   );
  //   console.log("datao", data);
  //   setRestaurantData(data);
  // }, []);
  function getCookie(name) {
    const cookies = document.cookie.split("; "); // Split cookies into individual name=value pairs
    for (let cookie of cookies) {
      const [key, value] = cookie.split("="); // Split each pair into a name and value
      if (key === name) {
        return decodeURIComponent(value); // Return the decoded value of the cookie
      }
    }
    return null; // Return null if the cookie is not found
  }
  const setRestaurantData = (data) => {
    dispatch({
      type: "SET_REST_DATA",
      payload: data,
    });
    console.log("restautnt data in context", data);
    let version = getCookie("version");
    if (data && data.version && version !== data?.version) {
      document.cookie = `version=${data?.version}; path=/`;
      window.location.reload();
    }
  };
  const setRestaurantTiming = (timing) => {
    dispatch({
      type: "SET_REST_TIMING",
      payload: timing,
    });
  };

  return (
    <RestaurantContext.Provider
      value={{
        restaurantData: state.restaurantData,
        setRestaurantData,
        setRestaurantTiming,
      }}
      {...props}
    />
  );
}

function ReloadProvider(props) {
  const [state, dispatch] = useReducer(ReloadReducer, initRelState);

  const setReload = (data) => {
    dispatch({
      type: "SET_RELOAD",
      payload: data,
    });
  };

  return (
    <ReloadContext.Provider
      value={{
        reload: state.reload,
        setReload,
      }}
      {...props}
    />
  );
}

export {
  RestaurantContext,
  RestaurantDataProvider,
  ReloadContext,
  ReloadProvider,
};
